import styled, { css } from "styled-components";

export const Container = styled.div<{
  $dashed?: boolean;
  $align?: "center" | "left";
  $compact?: boolean;
}>`
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: ${({ $align }) => ($align === "left" ? "flex-start" : "center")};
  justify-content: flex-start;
  padding: ${({ $compact }) => ($compact ? "12px 0" : "16px 16px 24px")};
  gap: 12px;
  box-sizing: border-box;

  ${({ $dashed }) =>
    $dashed &&
    css`
      padding: 40px 20px;
      border: 1px dashed #d9d9d9;
      border-radius: 12px;
      background: #fafafa;
    `}
`;

export const TextItem = styled.span<{ $align?: "center" | "left" }>`
  font-size: 14px;
  font-weight: 500;
  color: var(--gray);
  line-height: 1.5;
  text-align: ${({ $align }) => ($align === "left" ? "left" : "center")};
`;

